import Close from '@rover/icons/svg/close.svg';
import { Button } from '@rover/kibble/core';

import { DismissButtonProps } from './BottomSheet.common';

export const DismissButton: React.FC<DismissButtonProps> = ({
  isDismissible,
  hideCloseIcon,
  onRequestClose,
  closeOnDragDown,
}: DismissButtonProps) => {
  if (isDismissible && !hideCloseIcon && !closeOnDragDown) {
    return (
      <Button
        icon={Close}
        sx={{ padding: '4', border: 0 }}
        onClick={onRequestClose}
        size="small"
        data-testid="modal-dismiss-button"
        aria-label="Dismiss modal"
      />
    );
  }

  return null;
};
